import createAPIRequestId from "@/helpers/createAPIRequestId";
import handleError from "../helpers/handleError";
import store from "../store/index";

//------------------
// delete character skill
//------------------
export default async function useDeleteCharacterSkill(id) {
  // console.log("-------------------------------");
  // console.log("IN useDeleteCharacterSkill = ", id);
  let api_call = null;
  //--------------
  // access store
  //--------------
  const this_store = store;
  //--------------------
  // set api call parms
  //--------------------
  let request_parms = {
    endpoint: "api/v1/character-skills/",
    id: id,
    deleteInd: true,
  };
  //--------------------
  // create api request
  //--------------------
  let request = createAPIRequestId(request_parms);
  //------------------
  // set slug request
  //------------------
  let id_request = {
    request: request,
    id: id,
  };
  //--------------------------------
  // make store API call (deletion)
  //--------------------------------
  api_call = this_store.dispatch("characters/deleteCharacterSkill", id_request);
  //---------------
  // await results
  //---------------
  await api_call
    //----------
    // where ok
    //----------
    .then(() => {})
    //-------------
    // where error
    //-------------
    .catch((err) => {
      handleError(err,46);
    });
}
